import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import ChatIcon from '../../../../../assets/icons/secondary/Chat.svg';
import CameraIcon from '../../../../../assets/icons/secondary/Video.svg';
import {isChatConference} from '../../../../../utils/entity/conference/isChatConference';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, conference} = contexts;

  // @ts-expect-error: TODO: describe why
  const isChatSession = isChatConference(conference);

  const data: EventData = {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: i18n.t('shared:your_coach'),
    icon: isChatSession ? ChatIcon : CameraIcon,
    iconGradient: isChatSession ? 'info' : 'danger',
  };

  data.title =
    /**
     * @i18n_parser
     *
     * t('notifications:conference_client_joined.title.chat')
     * t('notifications:conference_client_joined.title.live')
     */
    i18n.t(
      `notifications:conference_client_joined.title.${
        isChatSession ? 'chat' : 'live'
      }`,
      {
        clientName: actor?.name || 'User not found',
      },
    );

  return data;
};
